@if (model()) {
  <form [formGroup]="formGroup" class="row gap-md-0 gap-4">
    <div class="col-12 col-md-6">
      <div class="row gap-4">
        <div class="col-sm-12"><h5 class="m-0">{{ 'CUSTOMERS.GEOLOCATION' | translate }}</h5></div>
        <!-- LATITUDE -->
        <div class="col-sm-12">
          <app-form-input [controlName]="'partnerLatitude'"
                          [formGroup]="formGroup"
                          [id]="'partnerLatitude'"
                          [label]="'CUSTOMERS.LATITUDE'"
                          [type]="'number'"
                          [min]="-90"
                          [max]="90"
                          [allowDecimalNumbers]="true"></app-form-input>
        </div>
        <!-- LONGITUDE -->
        <div class="col-sm-12">
          <app-form-input [controlName]="'partnerLongitude'"
                          [formGroup]="formGroup"
                          [id]="'partnerLongitude'"
                          [label]="'CUSTOMERS.LONGITUDE'"
                          [type]="'number'"
                          [min]="-180"
                          [max]="180"
                          [allowDecimalNumbers]="true"></app-form-input>
        </div>
        <!-- DATE LOCALIZATION -->
        <div class="col-sm-12">
          <app-form-input [controlName]="'dateLocalization'"
                          [formGroup]="formGroup"
                          [id]="'dateLocalization'"
                          [label]="'CUSTOMERS.DATE_LOCALIZATION'"
                          [type]="'date'"></app-form-input>
        </div>
      </div>
    </div>
  </form>
  <div class="d-flex justify-content-end align-items-center mt-4">
    <app-mdb-button (onClick)="submit()" [loading]="loading" [text]="'SAVE'"></app-mdb-button>
  </div>
} @else {
  <app-spinner></app-spinner>
}
